import { useDispatch, useSelector } from "react-redux";
import { updateTutorialState } from "./TutorialActions";
import { useNavigate } from "react-router-dom";

export const Header = ({ showProgress = true, successMessage }) => {
  const activeStep = useSelector((state) => state.tutorials_states.activeStep);
  const totalSteps = useSelector((state) => state.tutorials_states.totalSteps);
  const activeTutorial = useSelector(
    (state) => state.tutorials_states.activeTutorial
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBack = () => {
    dispatch(updateTutorialState({ activeStep: activeStep - 1 }));
  };

  const handleClose = () => {
    if (activeTutorial === "first-video-analyzed") {
      navigate("/videos");
      dispatch(
        updateTutorialState({
          isTutorial: true,
          activeTutorial: "first-video-analyzed",
          activeStep: 0,
          // totalSteps: 2,
        })
      );

      if (activeStep == 2) {
        localStorage.removeItem("firstVideoAnalysisId")
        // Closeing modal after first video analysed tutorial
        dispatch(
          updateTutorialState({
            isTutorial: false,
            activeTutorial: "",
            activeStep: 1,
            totalSteps: 0,
          })
        );
      }
    } else {
      navigate("/home");
      dispatch(
        updateTutorialState({
          isTutorial: false,
          activeTutorial: "",
          activeStep: 1,
          isVistComplete: true,
        })
      );
    }

    // TODO:
    localStorage.removeItem("toturialScreen");
  };

  return (
    <div className="header">
      {activeStep !== 1 && (
        <p className="back-button" role="button" onClick={() => handleBack()}>
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="13"
            viewBox="0 0 8 13"
            fill="none"
          >
            <path d="M7 1L1 6.7037L6 12" stroke="#783AD0" />
          </svg>{" "}
          Back{" "}
        </p>
      )}
      <p className="step-label">
        {activeStep}
        <span className="disable">/{totalSteps}</span>
      </p>
      <div className="close-btn">
        <img
          onClick={() => handleClose()}
          src={require("@src/assets/images/vyrill/cross.png").default}
          alt=""
          role="button"
          width="25px"
        />
      </div>
      {showProgress && (
        <ProgressInSteps
          active={activeStep}
          totalSteps={totalSteps}
          successMessage={successMessage}
        />
      )}
      {successMessage && (
        <span className="success-message">{successMessage}</span>
      )}
    </div>
  );
};

const ProgressInSteps = ({ active, totalSteps }) => {
  return (
    <div className="progressStep">
      {[...Array(totalSteps)].map((_, index) => (
        <div
          key={index}
          className={`dots ${index < active ? "active" : ""}`}
        ></div>
      ))}
    </div>
  );
};

export const BuletTick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
    >
      <path
        d="M4.13132 7.9773L1.04946 4.83313L0 5.89626L4.13132 10.1111L13 1.06314L11.9579 0L4.13132 7.9773Z"
        fill="#23BBB8"
      />
    </svg>
  );
};
